import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { StaffBasicInfo } from '@core/models/global-entities/global-entities';
import { HttpClient } from '@angular/common/http';

export class KMTTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private staffDependency: Observable<StaffBasicInfo>,
    private urlGenerator: (staff: StaffBasicInfo, langCode: string) => string
  ) {}

  public getTranslation(lang: string): Observable<Object> {
    return this.staffDependency.pipe(
      switchMap((staffInfo) =>
        this.http.get(this.urlGenerator(staffInfo, lang))
      )
    );
  }
}
